/** @deprecated remove in v4  */
export var PriceVariant;
(function (PriceVariant) {
    PriceVariant["PRIMARY"] = "main";
    PriceVariant["SECONDARY"] = "main-price";
})(PriceVariant || (PriceVariant = {}));
export var PriceLevel;
(function (PriceLevel) {
    PriceLevel[PriceLevel["LEVEL1"] = 1] = "LEVEL1";
    PriceLevel[PriceLevel["LEVEL2"] = 2] = "LEVEL2";
    PriceLevel[PriceLevel["LEVEL3"] = 3] = "LEVEL3";
    PriceLevel[PriceLevel["LEVEL4"] = 4] = "LEVEL4";
    PriceLevel[PriceLevel["LEVEL5"] = 5] = "LEVEL5";
    PriceLevel[PriceLevel["LEVEL6"] = 6] = "LEVEL6";
    PriceLevel[PriceLevel["LEVEL7"] = 7] = "LEVEL7";
})(PriceLevel || (PriceLevel = {}));
//# sourceMappingURL=PriceEnum.js.map